import React from "react";

import WidgetDetail from "./widget-detail";

interface Props {
  entity: any;
}

function WidgetDetailContainer(props: Props) {
  const { entity } = props;

  return <WidgetDetail entity={entity}></WidgetDetail>;
}

export default WidgetDetailContainer;
